import {createContext, useContext} from 'react';
import {ExportDataContextType} from './types';

export const ExportDataContext = createContext<ExportDataContextType | null>(null);

export const useExportDataContext = () => {
  const context = useContext(ExportDataContext);

  if (!context) {
    throw new Error('useExportDataContext must be used within an ExportDataProvider');
  }

  return context;
};
